// 缴费服务
import Log from '../view/log'
import PayServiceNav from '../view/PayService/PayServiceNav'
import ReceivingAccountConfiguration from '../view/PayService/ReceivingAccountConfiguration/ReceivingAccountConfiguration'
import ReceivingAccountModify from '../view/PayService/ReceivingAccountConfiguration/ReceivingAccountModify'
import PayRecord from '../view/PayService/PayRecord/PayRecord'

export default [
    /* 缴费服务 */
    {
        path: '/pay_server/receiving_account_configuration',
        name: 'receiving-account-configuration',
        components: {
            default: PayServiceNav,
            a: ReceivingAccountConfiguration
        }
    },
    {
        path: '/pay_server/receiving_account_modify',
        name: 'receiving-account-modify',
        components: {
            default: PayServiceNav,
            a: ReceivingAccountModify
        }
    },
    {
        path: '/pay_server/pay_record',
        name: 'pay-record',
        components: {
            default: PayServiceNav,
            a: PayRecord
        }
    },
    /* 缴费服务 */

    // 缴费服务操作日志
    {
        path: '/pay_service_log',
        name: 'pay-service-log',
        components: {
            default: PayServiceNav,
            a: Log
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/PayService.js